module.exports = __webpack_public_path__ + "assets/img/2035b51df6333294ac9706b15c80155d.png";